import { faBolt, faCheck, faTimes } from '@fortawesome/pro-regular-svg-icons';
import {
  faQuestionCircle,
  faArrowPointer,
  faCircleX,
  faShieldCheck,
} from '@fortawesome/pro-solid-svg-icons';

import '../styles/componentStyles/TopThreeChart.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { activity_list, reasonStress } from '../../shared/components/data';

function TopThreeChart(props) {
  const { t } = useTranslation();
  const titleId = props.title?.replace(/\s+/g, '');
  const [values, setValues] = useState(null);
  // const [progress, setProgress] = useState("50%");
  const [totalValue, setTotalValue] = useState(null);

  useEffect(() => {
    if (props.data && props.data.length > 0 && props.data[0] !== null) {
      const valuesArr = [];
      if (props.title === t('D061')) {
        // top three activities
        props.data.forEach((item) => {
          const activity = activity_list.find((el) => el.id === item.id);
          valuesArr.push({
            id: item.id,
            value: item.value,
            label: activity.label,
          });
        });
      } else {
        // top three causes of stress
        props.data.forEach((item) => {
          const reason = reasonStress.find((el) => el.id === item.id);
          valuesArr.push({
            id: item.id,
            value: item.value,
            label: reason.label,
          });
        });
      }
      valuesArr.sort((a, b) => b.value - a.value);
      setValues(valuesArr);
      let totalVal = 0;
      for (let i = 0; i < props.data.length; i++) {
        totalVal += parseFloat(props.data[i].value);
      }
      setTotalValue(totalVal);
    }
  }, [props.data]);

  return (
    <div
      className={`chart-container ${props.width}`}
      role="group"
      aria-labelledby={`${titleId}-top-three-chart-title`}
    >
      <div className="title-container">
        <h3 className="title" id={`${titleId}-top-three-chart-title`}>
          {props.title}
        </h3>
        <button
          className="wtf transparent-button"
          onClick={() => props.openModal(props.title, props.modalText)}
        >
          <span className="visuallyHidden">{t('open.modal.chart.information')}</span>
          <FontAwesomeIcon icon={faQuestionCircle} className="wtf icon" />
        </button>
      </div>
      <div className="top-three-list fs-mask">
        {values &&
          values.map((item, index) => {
            if (index < 3) {
              return (
                <div className="row" key={index}>
                  <div className="row-title">{t(item.label)}</div>
                  <div className="row-content">
                    <div className="progress-container">
                      <div
                        className="progress"
                        style={{ width: `${(item.value * 100) / totalValue}%` }}
                      />
                    </div>
                    <div className="values">
                      <div className="value">{item.value}</div>
                      <div className="units">{props.units}</div>
                    </div>
                  </div>
                </div>
              );
            }
          })}
        {!values && <div className="chart-no-data">{t('D075')}</div>}
      </div>
    </div>
  );
}

export default TopThreeChart;
